import ReactDOM from "react-dom";
import App from "./App.jsx";
import "./css/reset.css";
import "./css/index.css";

ReactDOM.render(<App />, document.getElementById("root"));
